import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .new-token-container {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-right: 12px;
    gap: 24px;
  }

  .new-token-title {
    color: #000;

    margin-bottom: 20px;

    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .new-token-toggle {
    width: 314px;

    margin-bottom: 32px;
  }

  .new-token-subtitle {
    display: flex;
    align-items: center;

    width: 100%;

    margin: 30px 0;

    color: #070707;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
  }

  .new-token-div-juros {
    display: flex;
    justify-content: space-around;
    width: 315px;
  }

  .new-token-div-prazo {
    display: flex;
    justify-content: flex-start;
    position: relative;
    width: 315px;
  }

  .new-token-plus {
    margin-top: 12px;
    color: var(--Cinza-claro, #9c948c);
    text-align: center;

    /* A - Link ou legendas - Light */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }

  .new-token-checkbox {
    display: flex;

    margin-bottom: 32px;
  }

  .new-plus-icon {
    padding: 1px;
    border: 1px solid black;
    border-radius: 25px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    margin-bottom: 12px;
  }
  /* @media only screen and (max-width: 1440px) {
    .new-token-container {
      width: 80%;
    }
  } */
`
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;

  .selected-client-name {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    width: 252px;
    padding: 13px;
    border: 1px solid #cccccc;
    border-radius: 5px;
  }

  .selected-cliente-trash {
    width: 19px;
    margin-left: 20px;
    cursor: pointer;
  }
`
export const Suffix = styled.span`
  position: absolute;
  right: 78%;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`

export const Unidade = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
`
export const InputError = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  margin: 0 0 15px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: rgb(214, 18, 18);
`
export const ShowToolTipContainer = styled.div`
  display: flex;
  gap: 8px;
  position: relative;
  align-items: center;
  .icon {
    width: 16px;
    height: 16px;
  }
  .tooltip {
    display: inline-block;
    visibility: hidden;
    position: absolute;
    top: -40px;
    right: 0;
    background-color: black;
    color: #fff;
    display: flex;
    padding: 4px 8px;
    flex-direction: column;
    border-radius: 4px;
  }
  .tooltip::after {
    content: ' ';
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
  .tooltip-txt {
    font-weight: 400;
    font-size: 10px;
    line-height: 13.23px;
    text-align: center;
    font-family: Inter;
  }
  .bold {
    font-weight: 700;
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`
